import { useAbTestComponent, loadLazyComponent, loadUsualComponent } from "@hook";
import { inject, observer } from "mobx-react";

import Default from "./Default";

const abTests = {};

const ListItemAccordion = inject("mainStore")(
    observer(({ mainStore, ...props }) => {
        const init = mainStore.getMainStore("init");
        const Specified = useAbTestComponent({ init, abTests, defaultComponent: Default });

        return <Specified {...props} />;
    }),
);

export default ListItemAccordion;
